import React, { useState, useEffect } from 'react'
import { getRandomValue } from '../HelperFunctions'
import Balloon from './Balloon'
import Header from './Header'

const Playground: React.FC = () => {
	const [ballonPosition, setBallonPosition] = useState({
		top: '50%',
		left: '50%',
	})
	const [counter, setCounter] = useState(0)

	const incrementCounter = () => {
		setCounter(counter + 1)
	}

	useEffect(() => {
		setBallonPosition({
			top: getRandomValue('13'),
			left: getRandomValue('6'),
		})
	}, [counter])

	return (
		<div onClick={incrementCounter}>
			<div className="full-screen bg-salmon"></div>
			<Header color={'#fa8072'} />
			<Balloon balloonPosition={ballonPosition} counter={counter} />
		</div>
	)
}

export default Playground
